module.exports = __webpack_public_path__ + "static/media/pets.ba9bd334.png";